import { apiClient } from './client';
import type { Severity } from '@ixam/shared';

export interface DashboardStats {
  servers: {
    total: number;
    byHealth: Partial<Record<'ok' | 'warning' | 'critical' | 'unknown', number>>;
  };
  events24h: {
    total: number;
    bySeverity: Partial<Record<Severity, number>>;
  };
}

export async function getDashboardStats(): Promise<DashboardStats> {
  const res = await apiClient.get<DashboardStats>('/dashboard/stats');
  return res.data;
}
